import type { SxProps, Theme } from '@mui/material';

export const styles = {
    paper: { p: 0, m: 0, width: '100%' } as SxProps<Theme>,
    header: {
        display: 'flex',
        justifyContent: 'center',
        py: 2,
    } as SxProps<Theme>,
    title: {
        fontSize: '20px',
        fontWeight: 500,
        color: 'grey.900',
    } as SxProps<Theme>,
    innerCard: {
        my: 1,
        mx: { xs: 0, sm: 2, md: 6 },
        py: 2,
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
    } as SxProps<Theme>,
    field: (filled: boolean, required: boolean, theme: Theme): SxProps<Theme> => ({
        p: 1,
        my: 1,
        backgroundColor:
            required && !filled
                ? theme.palette.red[30]
                : filled
                    ? theme.palette.blue[30]
                    : theme.palette.white,
        borderRadius: '4px',
        transition: 'background-color 0.15s ease',
    }),
    addServiceRow: {
        display: 'flex',
        justifyContent: 'center',
        py: 2,
    } as SxProps<Theme>,
    addServiceBtn: (theme: Theme): SxProps<Theme> => ({
        color: theme.palette.blue[700],
        borderColor: theme.palette.blue[700],
        width: { xs: '100%', sm: '80%', md: '60%' },
        textTransform: 'none',
    }),
};
